const Code = {
  1: "LEFT_POP_AKH",
  2: "LEFT_POP_AK",
  3: "RIGHT_POP_AKH",
  4: "RIGHT_POP_AK",
  5: "LEFT_POP",
  6: "RIGHT_POP",
  7: "LEFT_UP_POP",
  8: "RIGHT_UP_POP",
};

/**2 door - 1 window
 * @param {1 | 2} doorOrWindow
 * @param code
 * @return {[string]|number}
 */
function GetPopModel(doorOrWindow, code) {
  return doorOrWindow === 1 ? Code[code] : Code[code] + "_D";
}

export default GetPopModel;
